module.exports = __webpack_public_path__ + "img/Home.73d721b5.png";